import { environment } from 'src/environments/environment';

export interface IDomain {
  favicon: string;
  fullUrl: string;
  apiUrl: string;
  logoDarkBg: string;
  logoLightBg: string;
  name: string;
  url: string;
}

export const Domains: { [key: string]: IDomain } = {
  default: {
    url: environment.DOMAIN_URL.split('://')[1],
    fullUrl: environment.DOMAIN_URL,
    apiUrl: environment.API_BASE_URL,
    name: 'equal all',
    logoLightBg: 'assets/images/equalall-logo-light-bg1.png',
    logoDarkBg: 'assets/images/equalall-logo-dark-bg1.png',
    favicon: 'assets/favicon.ico',
  },
  'dev.equalall.org': {
    url: 'dev.equalall.org',
    fullUrl: 'https://dev.equalall.org',
    apiUrl: 'https://dev.equalall.org/api/',
    name: 'equal all',
    logoLightBg: 'assets/images/equalall-logo-light-bg1.png',
    logoDarkBg: 'assets/images/equalall-logo-dark-bg1.png',
    favicon: 'assets/favicon.ico',
  },
  'dev1.equalall.org': { 
    url: 'dev1.equalall.org',
    fullUrl: 'https://dev1.equalall.org',
    apiUrl: 'https://dev1.equalall.org/api/',
    name: 'equal all',
    logoLightBg: 'assets/images/equalall-logo-light-bg1.png',
    logoDarkBg: 'assets/images/equalall-logo-dark-bg1.png',
    favicon: 'assets/favicon.ico'
  },
  'dev2.equalall.org': {
    url: 'dev2.equalall.org',
    fullUrl: 'https://dev2.equalall.org',
    apiUrl: 'https://dev2.equalall.org/api/',
    name: 'equal all',
    logoLightBg: 'assets/images/equalall-logo-light-bg1.png',
    logoDarkBg: 'assets/images/equalall-logo-dark-bg1.png',
    favicon: 'assets/favicon.ico',
  },
  'equalall.org': {
    url: 'equalall.org',
    fullUrl: 'https://www.equalall.org',
    apiUrl: 'https://equalall.org/api/',
    name: 'equal all',
    logoLightBg: 'assets/images/equalall-logo-light-bg1.svg',
    logoDarkBg: 'assets/images/equalall-logo-dark-bg1.svg',
    favicon: 'assets/favicon.ico',
  },
  'dev.equalallusa.org': {
    url: 'dev.equalallusa.org',
    fullUrl: 'https://dev.equalallusa.org',
    apiUrl: 'https://dev.equalallusa.org/api/',
    name: 'equal all USA',
    logoLightBg: 'assets/images/surrogate/equalall_usa_logo_light.png',
    logoDarkBg: 'assets/images/surrogate/equalall_usa_logo_dark.png',
    favicon: 'assets/favicon.ico',
  },
  'equalallusa.org': {
    url: 'equalallusa.org',
    fullUrl: 'https://www.equalallusa.org',
    apiUrl: 'https://equalallusa.org/api/',
    name: 'equal all USA',
    logoLightBg: 'assets/images/surrogate/equalall_usa_logo_light.png',
    logoDarkBg: 'assets/images/surrogate/equalall_usa_logo_dark.png',
    favicon: 'assets/favicon.ico',
  },
  'equalallaid.org': {
    url: 'equalallaid.org',
    fullUrl: 'https://www.equalallaid.org',
    apiUrl: 'https://equalallaid.org/api/',
    name: 'equal all AID',
    logoLightBg: 'assets/images/surrogate/equalall_aid_logo_light.png',
    logoDarkBg: 'assets/images/surrogate/equalall_aid_logo_dark.png',
    favicon: 'assets/favicon.ico',
  },
};